import {isIE} from '../../js/tests';

(function () {
    let ieWarning = {
        html: '<div class="ie-warning"><div class="ie-warning__text">The site is best supported on modern browsers like Chrome, Safari, Firefox and Edge.</div><button class="btn ie-warning__btn">Got it</button></div>',
        parent: 'header',
        selectors: {
            target: 'header',
            content: '.content',
            warning: '.ie-warning',
            button: '.ie-warning__btn',
        },
        targetEl: null,
        contentEl: null,
        init: function () {
            const ie = isIE;
            if (!sessionStorage.getItem('ieWarning') && ie && ie < 12) {
                this.targetEl = document.querySelector(this.selectors.target);
                this.showMessage();
            }
        },
        showMessage: function () {
            ieWarning.targetEl.insertAdjacentHTML('afterbegin', this.html);
            document.querySelector(ieWarning.selectors.button).addEventListener('click', this.handlers.btnClickHandler);
            ieWarning.contentEl = document.querySelector(ieWarning.selectors.content);
            if (ieWarning.contentEl) {
                ieWarning.contentEl.style.paddingTop =
                    parseInt(window.getComputedStyle(ieWarning.contentEl).paddingTop) +
                    document.querySelector(ieWarning.selectors.warning).clientHeight +
                    'px';
            }
        },
        removeMessage: function () {
            if (sessionStorage) {
                sessionStorage.setItem('ieWarning', 'shown');
            }
            document
                .querySelector(ieWarning.selectors.button)
                .removeEventListener('click', this.handlers.btnClickHandler);
            const child = document.querySelector(ieWarning.selectors.warning);
            if (ieWarning.contentEl) {
                ieWarning.contentEl.style.paddingTop =
                    parseInt(window.getComputedStyle(ieWarning.contentEl).paddingTop) - child.clientHeight + 'px';
            }
            ieWarning.targetEl.removeChild(child);
        },
        handlers: {
            btnClickHandler: function (ev) {
                ieWarning.removeMessage();
            },
        },
    };

    UX.ieWarning = ieWarning;
    UX.ieWarning.init();
})();
